import TrialFormBase from '../common/TrialFormBase';

/**
 * Free-trial signup form (templates/Element/website/signup_form.php).
 * Shares the whole submission flow with the contact form via TrialFormBase.
 */
export default class SignUpFormClass extends TrialFormBase {
    constructor(formId = 'free_signup-form') {
        super({
            formId,
            openEvent: 'open_form_signup',
            analyticsEvent: 'submit_form_signup'
        });
    }
}